<template>
  <div class="container">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <card class="card-login card-white">
            <template slot="header">
              <img src="img/card-primary.png" alt="" />
              <h1 class="card-title">Log in</h1>
            </template>

            <div>
              <base-input
                required
                v-model="email"
                type="text"
                placeholder="Email"
                addon-left-icon="tim-icons icon-email-85"
              >
              </base-input>

             <ValidationProvider
               name="password"
               rules="required|min:2"
               v-slot="{ passed, failed, errors }"
             >
             <base-input
               required
               v-model="password"
               placeholder="Password"
               addon-left-icon="tim-icons icon-lock-circle"
               type="password"
               :error="errors[0]"
               :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
             </base-input>
            </ValidationProvider>
            </div>

            <div slot="footer">
              <base-button native-type="submit" type="primary" class="mb-3" size="lg" block>
                Uloguj se
              </base-button>
              <div class="pull-left">
                <h6>
                  <!-- <router-link class="link footer-link" to="/register">
                    Create Account
                  </router-link> -->
                </h6>
              </div>

              <div class="pull-right">
                <!-- <h6><a href="#pablo" class="link footer-link">Need Help?</a></h6> -->
              </div>
            </div>
          </card>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>

import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import axios from 'axios'

extend("email", email);
extend("min", min);

extend("required", required);

export default {
  data() {
    return {
      email: "",
      password: "",
      subscribe: true,
      url: 'https://budva.scancar.org:8443/kuca/login'
    };
  },
  methods: {
    submit() {
      const body = {
        "username": this.email,
        "password": this.password
      }
      axios.post(this.url + '/login', body).then(result => {
          
          if (result.data.result === 'ok') {
            localStorage.setItem('access_token', result.data.token);
            localStorage.setItem('user', JSON.stringify(result.data));

            this.$router.push('/dashboard');
          } else {
            alert(result.data.reason)

          }

         
      })
    }
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
